var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.559,
    height: 15,
    viewBox: "0 0 13.559 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#666;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.652 0v4.565a.609.609 0 0 1-.609.609H0",
    className: "cls-1",
    transform: "translate(8.522 7.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M0 7.3V.609A.609.609 0 0 1 .609 0h5.174",
    className: "cls-1",
    "data-name": "Shape",
    transform: "translate(1.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M7.913 1.217H3.652a.609.609 0 0 1-.487-.243L2.617.243A.609.609 0 0 0 2.13 0H.609A.609.609 0 0 0 0 .609v5.478a.609.609 0 0 0 .609.613h7.3a.609.609 0 0 0 .609-.609V1.826a.609.609 0 0 0-.605-.609z",
    className: "cls-1",
    "data-name": "Shape",
    transform: "translate(0 7.305)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.522,
    cy: 1.522,
    r: 1.522,
    className: "cls-1",
    transform: "translate(8.522 .913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    d: "M0 1.294a2.739 2.739 0 0 1 4.654 0",
    className: "cls-1",
    "data-name": "Shape",
    transform: "translate(7.717 4.565)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlan);
export default __webpack_public_path__ + "static/media/icon-plan.7b49b2e3ed34558f2d901740fe967f0d.svg";
export { ForwardRef as ReactComponent };